export default __webpack_public_path__ + "static/media/High-Speed Stabbing.4c04810d.png";